// marqueeContext.js
// Context-aware marquee filtering. Each marquee message can carry a `context`
// tag — "stream" (only when broadcasting), "booth" (only at the physical booth),
// or "both" (always eligible). Missing context defaults to "both" so legacy
// messages keep playing in every mode.
//
// The active context is stamped on the shift doc at open time (or flipped from
// the active-shift HUD). Overlays read activeShift.contextMode and filter the
// marquee through here before passing it to MarqueeTicker.

export const CONTEXT_MODES = ["stream", "booth", "both"];

export function normalizeContextMode(mode) {
  if (mode === "stream" || mode === "booth" || mode === "both") return mode;
  return "stream";
}

export function messageMatchesContext(msg, mode) {
  const ctx = msg?.context || "both";
  if (mode === "both") return true;
  return ctx === "both" || ctx === mode;
}

export function filterMarqueeForContext(messages, mode) {
  const m = normalizeContextMode(mode);
  return (messages || []).filter((msg) => messageMatchesContext(msg, m));
}

// Per-shift override layer. The active shift can opt out of individual
// marquee messages for one shift only (e.g. venue-specific copy that's
// only relevant at certain events). We key by the message's `text` because
// marquee items don't carry stable IDs — texts are unique within the
// config, and per-shift overrides are short-lived, so a mid-shift edit
// of the text simply re-enables the message (acceptable edge case).
export function filterMarqueeForShift(messages, mode, shift) {
  const ctxFiltered = filterMarqueeForContext(messages, mode);
  const disabled = shift?.disabledMarqueeTexts;
  if (!Array.isArray(disabled) || disabled.length === 0) return ctxFiltered;
  const skip = new Set(disabled);
  return ctxFiltered.filter((m) => !skip.has(m?.text));
}
